import getAvailabilitySlotStatus, {
  type AvailabilitySlotStatusProperties,
} from "./getAvailabilitySlotStatus";
import type { Prettify } from "../../types";

type AvailableSlot = Prettify<
  Omit<AvailabilitySlotStatusProperties, "open" | "available" | "time"> & {
    open: true;
    available: true;
    time: string;
  }
>;

export default function isSlotAvailable(
  slot: AvailabilitySlotStatusProperties,
  people?: number | null,
): slot is AvailableSlot {
  return getAvailabilitySlotStatus(slot, people) === "available";
}
